import { Appointment, CoreAppointment } from "./interfaces"

export const isTransferAppointment = (a: Appointment | CoreAppointment): a is Appointment => {
  return 'transferStatus' in a && 'items' in a;
} 